export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14608.2c21bfea.jpg";